module.exports = __webpack_public_path__ + "static/media/logo_e4_p.160f35d2.png";